import { Pipe, PipeTransform } from '@angular/core';
import { ProductService } from '../../../services/product.service';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { UsersService } from '../../../services/users.service';

@Pipe({
  name: 'adrTooltip'
})
export class AdrTooltipPipe implements PipeTransform {

  constructor(
    private productService: ProductService,
    private userService: UsersService
  ) { }

  transform(value: any): Observable<string> {

    return combineLatest(
      this.productService.adrKeys$,
      this.userService.currentUser$
    ).pipe(
      map(([keys, user]) => {
        const findKey = keys.find(x => x.key === value);
        if (!findKey) { console.error('Key not found for ADR tooltip'); return ''; }
        if (findKey.tooltip[user.language]) {
          return findKey.tooltip[user.language];
        } else if (findKey.tooltip.english) {
          return findKey.tooltip.english;
        } else {
          return findKey.key;
        }
      })
    );

  }

}
